import { OrdenTrabajo } from "@/shared/interfaces";

// Pura: arma el objeto que se le pasa a `form.reset(...)`. No muta nada,
// no llama a nada — solo transforma datos.
export function mapearOrdenTrabajoAFormValues(
  ordenTrabajo: OrdenTrabajo,
  formaPagoActual?: Record<string, any>,
) {
  const { prospecto_data, preventa_data, agendamiento_data, contrato_data, ...rest } =
    ordenTrabajo;
  const estado_navegacion_contrato = contrato_data?.estado_navegacion;
  const tag = contrato_data?.tag;

  return {
    ...prospecto_data,
    ...preventa_data,
    ...agendamiento_data,
    ...rest,
    ssid: ordenTrabajo?.contrato_data?.ssid || "",
    password_wifi: ordenTrabajo?.contrato_data?.password_wifi || "",
    fecha_hora_inicio_instalacion: ordenTrabajo?.fecha_hora_inicio_instalacion,
    estado_navegacion_contrato,
    planLabel: ordenTrabajo?.plan_data?.nombre || "",
    flotaLabel: ordenTrabajo?.flota_data?.nombre || "",
    tipo_instalacion:
      ordenTrabajo?.tipo_instalacion || preventa_data?.tipo_instalacion || "",
    subtipo_instalacion: ordenTrabajo?.subtipo_instalacion || "",
    valor_instalacion: preventa_data?.valor_instalacion || "",
    observacion_activacion: ordenTrabajo?.observaciones?.observacion_activacion,

    observacion_1: ordenTrabajo?.preventa_data?.observaciones?.observacion_1,
    observacion_2: ordenTrabajo?.preventa_data?.observaciones?.observacion_2,
    observacion_tecnico: ordenTrabajo?.observaciones?.observacion_tecnico || "",
    observacion_llamada: agendamiento_data?.observaciones?.observacion_llamada,
    observacion_incidencia: ordenTrabajo?.observaciones?.observacion_incidencia || "",

    metraje_autorizado: rest?.ciudad_data?.metraje_autorizado || "0",

    es_conexion_tierra: !!rest?.es_conexion_tierra,
    es_regulador: !!rest?.es_regulador,

    ///* Activacion ---
    rawNap: rest.nap_data,
    nap: rest.nap || "",
    ont_a_utilizar: rest?.equipos_utilizados?.[0] || "",
    puntos_red_instalados: rest?.puntos_red_instalados || "0",
    puntos_red_no_instalados: rest?.puntos_red_no_instalados || "0",
    routers_adicionales_instalados: rest?.routers_adicionales_instalados || 0,
    forma_pago_adicionales_tecnico: rest?.forma_pago_adicionales_tecnico || null,

    ...(ordenTrabajo?.forma_pago_adicionales_tecnico &&
      Object.keys(ordenTrabajo.forma_pago_adicionales_tecnico).length > 0 && {
        forma_pago_aux: formaPagoActual?.forma_pago,
        metodo_pago_mensualidad_aux: formaPagoActual?.metodo_pago_mensualidad,
        valor_instalacion_total_aux: formaPagoActual?.valor_instalacion_total,
        valor_instalacion_aux: formaPagoActual?.valor_instalacion,
        valor_instalacion_iva_aux: formaPagoActual?.valor_instalacion_iva,
        numero_cuenta_aux: formaPagoActual?.numero_cuenta,
        tipo_cuenta_bancaria_aux: formaPagoActual?.tipo_cuenta_bancaria,
        numero_tarjeta_aux: formaPagoActual?.numero_tarjeta,
        entidad_financiera_aux: formaPagoActual?.entidad_financiera,
        codigo_forma_pago_aux: formaPagoActual?.codigo_forma_pago,
        tipo_contrato_aux: formaPagoActual?.tipo_contrato,
        tarjeta_aux: formaPagoActual?.tarjeta,
      }),
    equipos_adicionales_preventa: ordenTrabajo?.preventa_data?.equipos_adicionales || null,
    tag,
  } as unknown as any;
}